import {styled} from '@linaria/react';
import {
  mediaDesktopAndUp,
  mediaLargeScreens,
  mediaTabletAndUp,
} from '../../../constants/customMedia';

export const ROW_SECTION_PADDING = {
  tabletAndUp: '20px',
  desktopAndUp: '30px',
  largeScreens: '60px',
};

export interface RowSectionProps {
  dataTestId?: string;
  pullStart?: boolean;
  pullEnd?: boolean;
  centerContent?: boolean;
  constrained?: boolean;
}

export const RowSection = styled.section<RowSectionProps>`
  width: 100%;
  margin-inline: auto;
  max-width: 1920px;

  display: ${({centerContent}) => (centerContent ? 'flex' : 'block')};
  justify-content: ${({centerContent}) => (centerContent ? 'center' : '')};

  --padding: 0;

  @media ${mediaTabletAndUp} {
    --padding: ${({constrained}) =>
      constrained ? '' : ROW_SECTION_PADDING.tabletAndUp};
  }

  @media ${mediaDesktopAndUp} {
    --padding: ${({constrained}) =>
      constrained ? '' : ROW_SECTION_PADDING.desktopAndUp};
  }

  @media ${mediaLargeScreens} {
    --padding: ${({constrained}) =>
      constrained ? '' : ROW_SECTION_PADDING.largeScreens};
  }

  padding-left: ${({pullStart}) => (pullStart ? '0' : 'var(--padding)')};
  padding-right: ${({pullEnd}) => (pullEnd ? '0' : 'var(--padding)')};
`;
